import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from './login/login-user-data.service';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private dataService: DataService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const userData = this.dataService.currentData();
    if (!userData || !userData.sub) {
      const token: string | null= sessionStorage.getItem('token') ?? null;
      if (!token) {
        this.router.navigate(['/login']);
        return false;
      }
      const decodedToken = jwtDecode(token);
      this.dataService.updateData({...decodedToken, access_token: token});
      return true;
    }

    if(route.url.toString().includes('usuario') && userData.master) {
        return true;
    } 
    // this.router.navigate(['/login']);
    return true;
  }
}